import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FieldControl, Validators, FormBuilder} from 'react-reactive-form';
import renderer from './renderers';
import validation from '../../../utils/validation';
import CustomValidators from './CustomValidators';
import data from '../../../utils/data';

class MetadataEditControl extends Component {
    constructor(props){
        super(props);

        this.countryData = data.getCountryData();
    };

    static initMetadata(metadata) {
        return {
            firstName:'',
            lastName:''
            // name: '',
            // cityLabel: '',
            // streetAddress: '',
            // postalCode: '',
            // countryLabel: '',
            // countryCode: ['', CustomValidators.countryCode],
            // admin1Label: '',
            // latitude: ['', Validators.pattern(validation.floatPattern)],
            // longitude: ['', Validators.pattern(validation.floatPattern)]
        };
    }

    componentDidMount() {
        // if (this.props.form) {
        //     var group = this.props.form.get(this.props.name);
        //     if (group) {
        //         var codeControl = group.get('countryCode');
        //         if (codeControl) {
        //             codeControl.valueChanges.subscribe((value) => {
        //                 var item = this.countryData.find((o) => {return o.code2 === value});
        //                 if (item) {
        //                     // update countryLabel in form (if it's empty)
        //                     var label = group.get('countryLabel');
        //                     if (label && label.value.length == 0) {
        //                         label.setValue(item.name);
        //                     }
        //                 }
        //             })
        //         }

        //         var labelControl = group.get('countryLabel');
        //         if (labelControl) {
        //             labelControl.valueChanges.subscribe((value) => {
        //                 var item = this.countryData.find((o) => {return o.name.toLowerCase() === value.toLowerCase()});
        //                 if (item) {
        //                     // update countryCode in form (if it's empty)
        //                     var code = group.get('countryCode');
        //                     if (code && code.value.length == 0) {
        //                         code.setValue(item.code2);
        //                     }
        //                 } 
        //             })
        //         }
        //     }
        // }
    }

    componentWillUnmount() {
        // if (this.props.form) {
        //     var group = this.props.form.get(this.props.name);
        //     if (group) {
        //         var codeControl = group.get('countryCode');
        //         if (codeControl) {
        //             codeControl.valueChanges.unsubscribe();
        //         }

        //         var labelControl = group.get('countryLabel');
        //         if (labelControl) {
        //             labelControl.valueChanges.unsubscribe();
        //         }
        //     }
        // }
    }

    render() {
        return (
            <FieldControl name={this.props.name} render={renderer.metadata} 
                meta={{
                    label: this.props.label, 
                    hidden: this.props.hidden
                }}
            />
        );
    };
}

MetadataEditControl.propTypes = {
    name: PropTypes.string.isRequired,
    form: PropTypes.object.isRequired,
    hidden: PropTypes.array,
    label: PropTypes.string
};

export default MetadataEditControl;

